
window._ = require('lodash');
window.moment = require('moment');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */


require('bootstrap-sass');

window.GMaps = require('gmaps');

window.slugify = require('slugify');

/**
 * Vue is a modern JavaScript library for building interactive web interfaces
 * using reactive data binding and reusable components. Vue's API is clean
 * and simple, leaving you to focus on building your next great project.
 */

window.Vue = require('vue');

window.monthsList = _.times(12).map(i => {
    return { val: _.padStart((i + 1).toString(), 2, '0'), labelShort: moment.monthsShort(i), labelFull: moment.months(i) }

});

window.yearsList = _.range(moment().year(), moment().year() + 20);

import Form from 'form-backend-validation';
window.Form = Form;

import VeeValidate from 'vee-validate';
import VueCookie from 'vue-cookie';
import VueMq from 'vue-mq';
import VueMasonry from "vue-masonry-css";

Vue.use(VueCookie);
Vue.use(VeeValidate);
Vue.use(VueMasonry);
Vue.use(VueMq, {
  breakpoints: {
    479: 479,
    600: 600,
    767: 767,
    991: 991,
    1199: 1199,
    desktop: Infinity,
  }
});

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');
Vue.prototype.$http = axios;

window.axios.defaults.headers.common = {
    'X-CSRF-TOKEN': window.appVariables.csrf_token,
    'X-Requested-With': 'XMLHttpRequest'
};


// Global event bus
window.appVariables.bus = new Vue();

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: 'your-pusher-key'
// });
